export default class Accordion {
  constructor(element) {
    if (!element) {
      return;
    }
    this.element = element;
    for (const node of this.element.querySelectorAll('[data-click]')) {
      node.addEventListener('click', (event) => {
        const panelBody = event.currentTarget.parentNode.querySelector('.accordion__panel__body');
        if (event.currentTarget.parentNode.classList.contains('accordion__panel--active')) {
          event.currentTarget.parentNode.classList.remove('accordion__panel--active');
          if (panelBody) {
            panelBody.style.maxHeight = '0';
          }
        } else {
          event.currentTarget.parentNode.classList.add('accordion__panel--active');
          if (panelBody) {
            panelBody.style.maxHeight = `${panelBody.scrollHeight}px`;
          }
        }
      });
    }
  }
};
